import Vue from "vue";
import moment from "moment";

Vue.component("global-search", {
    props: ["placeholder","url"],
    data() {
        return {
            searchTerm: ''
        };
    },
    methods: {
        search: function () {
            this.setParams();
            window.location.href = this.url + escape(this.searchTerm);
        },
        setParams: function () {
            const url = window.location.pathname;
            let qs = '';
            if (this.searchTerm) {
                if (qs) qs += '&';
                qs += `freeText=${encodeURIComponent(this.searchTerm)}`;
            }

            if (qs) {
                window.history.pushState({}, '', url + '?' + qs);
            } else {
                window.history.pushState({}, '', url);
            }
        },
        getFreeText: function () {
            const url = new URL(window.location.href);
            const freeText = url.searchParams.get("freeText");
            if (freeText) {

                this.searchTerm = freeText;
            }
        }
    },
    mounted: function () {
        this.getFreeText();
    },
    template: `
		 <b-field>
             <b-input :placeholder="placeholder" v-model="searchTerm"
                      type="search"
                      icon-pack="fas"
                      icon="search"
                      icon-clickable
                      @icon-click="search"
                      @keyup.native.enter="search">
             </b-input>
         </b-field>
	`
});